import { Component, Input } from '@angular/core';

@Component({
  selector: 'pershing-disclaimer',
  templateUrl: 'pershing-disclaimer.component.html'
})
export class PershingDisclaimerComponent {

  showExpansion: boolean = true;
  showContent: boolean = true;
  @Input() disclaimers: string[];
  @Input() disclosures: string[];
  @Input() isExpanded: boolean = false;

  ngOnInit() {
    if (this.disclaimers == null && this.disclosures == null) {
      this.showContent = !this.showContent;
    }
  }

  toggleExpansion() {
    return this.showExpansion = !this.showExpansion;
  }
}
